import type { Filter, FirestoreQuery, OrderBy } from '@shared/types';

export function buildQueryFromState(
  conditions: Filter[],
  orderBy: OrderBy[],
  limit: number,
  collectionName: string
): FirestoreQuery | null {
  const filters = conditions
    .filter((c) => c.field && c.value !== '' && c.value !== null && c.value !== undefined)
    .map((c) => ({
      field: c.field,
      operator: c.operator,
      value: c.value,
    }));

  const orderByList = orderBy.filter((o) => o.field);

  if (filters.length === 0 && orderByList.length === 0 && !limit) {
    return null;
  }

  return {
    collection: collectionName,
    filters: filters.length > 0 ? filters : undefined,
    orderBy: orderByList.length > 0 ? orderByList : undefined,
    limit: limit > 0 ? limit : undefined,
  };
}

export function defaultSaveQueryName(): string {
  return `Query ${new Date().toLocaleString()}`;
}

export function isRunQueryDisabled(
  loading: boolean,
  connectionId: string | null,
  collectionName: string,
  orConditions: Filter[],
  testRunLoading?: boolean,
  testRunError?: string | null
): boolean {
  return (
    loading ||
    testRunLoading === true ||
    Boolean(testRunError) ||
    !connectionId ||
    !collectionName ||
    (orConditions.length > 0 && orConditions.length < 2)
  );
}

export function isOrErrorRelevant(error: string | null): boolean {
  return error !== null && (error.includes('orGroups') || error.includes('OR'));
}
